"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _default = exports.default = {
  name: 'Home',
  data: function data() {
    return {
      mainItem: [{
        title: '康复绿通',
        desc: '根据需求,协调入院',
        image: require('../../assets/images/lstd.png'),
        color: 'rgb(82, 169, 224)',
        path: '/kflt'
      }, {
        title: '私人康复师',
        desc: '一对一专业评估 ， 制定个性化指导 方案',
        image: require('../../assets/images/kfs.png'),
        color: 'rgb(146, 113, 189)',
        path: '/srkfs'
      }, {
        title: '床位费用减免',
        desc: '免除约定日期内医保外自费部分床位费',
        image: require('../../assets/images/fyjm.png'),
        color: 'rgb(239, 187, 88)',
        path: '/zyjm'
      }, {
        title: '远程康复指导',
        desc: '远程居家康复方案 ，远程带练',
        image: require('../../assets/images/kfzd.png'),
        color: 'rgb(125, 174, 84)',
        path: '/yckf'
      }]
    };
  },
  created: function created() {},
  methods: {
    gotoPage: function gotoPage(item) {
      this.$router.push(item.path);
    }
  }
};